export default __webpack_public_path__ + "static/media/bookese-icon.88c5a195.svg";